export const defaultSorted = [{ dataField: "id", order: "desc" }];
export const convertToStr = ["sku", "upc", "gtn", "mlc", "bin", "category_ids", "supplier_ids", "tag_values"];

export const initialFilter = {
  sortOrder: "desc", // asc||desc
  sortField: "created_at",
  pageNumber: +(localStorage.getItem("productTablePageNo") ?? 1),
  pageSize: +(localStorage.getItem("productTablePageSize") ?? 20),
  is_archived: 0,
  show_default: "",
  statuses: [1],
  show_stocks: 1,
};
